
import { defineComponent } from "vue";

import common from "../styles/common.module.less";

// 零二进制素材的封面底图：按 id 取确定性渐变，同一条信息配色恒定
const PALETTES: Array<[string, string]> = [
  ["#93c5fd", "#2563eb"],
  ["#fcd34d", "#f59e0b"],
  ["#6ee7b7", "#059669"],
  ["#c4b5fd", "#7c3aed"],
  ["#fca5a5", "#dc2626"],
  ["#7dd3fc", "#0284c7"],
];

export default defineComponent({
  name: "XiyouCoverThumb",
  props: {
    id: { type: Number, required: true },
    label: { type: String, default: "" },
    small: { type: Boolean, default: false },
  },
  setup(props) {
    return () => {
      const palette = PALETTES[Math.abs(props.id) % PALETTES.length];
      return (
        <div
          class={[common.cover, props.small ? common.coverSmall : null]}
          style={{
            backgroundImage: `linear-gradient(135deg, ${palette[0]}, ${palette[1]})`,
          }}
        >
          <span class={common.coverLabel}>{props.label.slice(0, 2)}</span>
        </div>
      );
    };
  },
});
